import { useMemo } from 'react'

import type { UserState } from '@app/store/user'
import { hasRole } from '@app/store/user/selectors'

import type { NavigationVisibleContextResult } from './types'
import { ROLE } from '../B2B/constants'

export const resolveB2CNavigationVisibleContext = (userState: UserState): NavigationVisibleContextResult => {
  const hasCurrentUser = Boolean(userState.currentUser.id)
  const hasUserRole = hasRole(userState)

  const isRoleAllowed = (allowedRoles: ReadonlyArray<string>): boolean => {
    return allowedRoles.some((role) => hasUserRole(role))
  }

  const isStaff = isRoleAllowed([ROLE.Staff])
  const isStaffAdmin = isRoleAllowed([ROLE.StaffAdmin])
  const isAgent = isRoleAllowed([ROLE.Agent])
  const isStandardOrHigher = isRoleAllowed([
    ROLE.Standard,
    ROLE.Admin,
    ROLE.Staff,
    ROLE.StaffAdmin,
  ])
  const isAdminOrHigher = isRoleAllowed([
    ROLE.Admin,
    ROLE.Staff,
    ROLE.StaffAdmin,
  ])
  const isAgentAccount = userState.account.type === 'Agent'

  return {
    visibilityContext: {
      hasCurrentUser,
      isStaff,
      isStaffAdmin,
      isAgent,
      isStandardOrHigher,
      isAdminOrHigher,
      isDeveloper: false,
      isPartner: false,
      isFranchise: false,
      hasProjects: false,
      showStoreMenu: false,
      canShowMandates: false,
      canShowReports: false,
      isTestEnv: false,
    },
    isActAs: false,
    hasCurrentUser,
    isStaff,
    isStaffAdmin,
    isAgent,
    isAdminOrHigher,
    isPartner: false,
    isFranchise: false,
    isAllowedToPromote: false,
    hasAccountId: false,
    isAgentAccount,
    showGlobalLink: false,
  }
}

export const useB2CNavigationVisibleContext = (userState: UserState): NavigationVisibleContextResult => {
  return useMemo(
    () => resolveB2CNavigationVisibleContext(userState),
    [userState]
  )
}
